import "./index.less";
import * as React from "react";
import { AtButton, AtContainer, AtTitle, DefaultSizes, IAtButtonProps } from "../../../internal";

export interface ITabCardProps extends React.HTMLProps<HTMLDivElement> {
    cardTitle: string;
    leftHeaderContent?: React.ReactNode;
    headerButtonProps?: IAtButtonProps[];
    rightHeaderContent?: React.ReactNode;
    paddingSize?: DefaultSizes;
}
// TODO Simon 2021-08-06: Use the new ComponentPadding prop here
export const TabCard: React.FC<ITabCardProps> = (props) => {
    const {
        cardTitle,
        className,
        id,
        leftHeaderContent,
        headerButtonProps,
        rightHeaderContent,
        paddingSize = "md",
        children,
        ...divProps
    } = props;

    const getClasses: () => string = () => {
        let classes: string = `TabCard padding-${paddingSize}`;

        if (className) {
            classes += ` ${className}`;
        }

        return classes;
    };

    return (
        <AtContainer
            className={getClasses()}
            header={
                <>
                    <div className="left-section d-flex align-items-center">
                        {leftHeaderContent}
                        <AtTitle title={cardTitle} headingType={4} noMargin />
                    </div>
                    {rightHeaderContent
                        ? rightHeaderContent
                        : headerButtonProps && (
                              <div className="buttons">
                                  {headerButtonProps
                                      ? headerButtonProps.map((x, i) => <AtButton key={i} {...x} />)
                                      : null}
                              </div>
                          )}
                </>
            }
            id={id}
            {...divProps}
        >
            <div className="content">{children}</div>
        </AtContainer>
    );
};
